/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Delete_Aria_LabelInputs */

const en_snapshot_history_delete_aria_label = /** @type {(inputs: Snapshot_History_Delete_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete selected commit`)
};

const fr_snapshot_history_delete_aria_label = /** @type {(inputs: Snapshot_History_Delete_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le commit selectionne`)
};

const de_snapshot_history_delete_aria_label = /** @type {(inputs: Snapshot_History_Delete_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählten Commit löschen`)
};

const it_snapshot_history_delete_aria_label = /** @type {(inputs: Snapshot_History_Delete_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina il commit selezionato`)
};

const ru_snapshot_history_delete_aria_label = /** @type {(inputs: Snapshot_History_Delete_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить выбранный коммит`)
};

const es_snapshot_history_delete_aria_label = /** @type {(inputs: Snapshot_History_Delete_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar la confirmación seleccionada`)
};

const zh_cn2_snapshot_history_delete_aria_label = /** @type {(inputs: Snapshot_History_Delete_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除选定的提交`)
};

const ja_snapshot_history_delete_aria_label = /** @type {(inputs: Snapshot_History_Delete_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したコミットを削除`)
};

const hi_snapshot_history_delete_aria_label = /** @type {(inputs: Snapshot_History_Delete_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित कमिट को हटाएं`)
};

const pt_pt2_snapshot_history_delete_aria_label = /** @type {(inputs: Snapshot_History_Delete_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir confirmação selecionada`)
};

/**
* | output |
* | --- |
* | "Delete selected commit" |
*
* @param {Snapshot_History_Delete_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_delete_aria_label = /** @type {((inputs?: Snapshot_History_Delete_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Delete_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snapshot_history_delete_aria_label(inputs)
	if (locale === "de") return de_snapshot_history_delete_aria_label(inputs)
	if (locale === "it") return it_snapshot_history_delete_aria_label(inputs)
	if (locale === "ru") return ru_snapshot_history_delete_aria_label(inputs)
	if (locale === "es") return es_snapshot_history_delete_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_snapshot_history_delete_aria_label(inputs)
	if (locale === "ja") return ja_snapshot_history_delete_aria_label(inputs)
	if (locale === "hi") return hi_snapshot_history_delete_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_snapshot_history_delete_aria_label(inputs)
	return en_snapshot_history_delete_aria_label(inputs)
});